import Flex from "components/grid/Flex";
import { useTranslation } from "react-i18next";
import HistoryContainerAndTitle from "./HistoryContainerAndTitle";
import { isAnyPresent, makeHistory } from "../../HistoryUtils";
import ConditionalLabelAndValue from "./ConditionalLabelAndValue";

const QualityOfLifeHistory = ({ anamnesisHistory }) => {
    const { t } = useTranslation();
    const history = makeHistory(anamnesisHistory);
    const isVisible = isAnyPresent(anamnesisHistory, [
        "mobileValue",
        "washAndDressValue",
        "dailyActivityValue",
        "discomfortValue",
        "anxiousValue",
        "scaleRateValue",
    ]);
    return (
        <HistoryContainerAndTitle title={t(`anamnesis.quality.shortTitle`)} isVisible={isVisible}>
            <Flex item grow={0} container column style={{ margin: "5px 0px" }}>
                {history.getLatestValueOf("mobileValue") && (
                    <ConditionalLabelAndValue
                        {...{
                            switchValue: history.getLatestValueOf("mobileValue") !== "NO_PROBLEM",
                            value:
                                history.getLatestValueOf("mobileValue") !== "NO_PROBLEM"
                                    ? t(`anamnesis.quality.${history.getLatestValueOf("mobileValue")}`)
                                    : "",
                            label: t("anamnesis.quality.mobility"),
                        }}
                    />
                )}
                {history.getLatestValueOf("washAndDressValue") && (
                    <ConditionalLabelAndValue
                        {...{
                            switchValue: history.getLatestValueOf("washAndDressValue") !== "NO_PROBLEM",
                            value:
                                history.getLatestValueOf("washAndDressValue") !== "NO_PROBLEM"
                                    ? t(`anamnesis.quality.${history.getLatestValueOf("washAndDressValue")}`)
                                    : "",
                            label: t("anamnesis.quality.self-care"),
                        }}
                    />
                )}
                {history.getLatestValueOf("dailyActivityValue") && (
                    <ConditionalLabelAndValue
                        {...{
                            switchValue: history.getLatestValueOf("dailyActivityValue") !== "NO_PROBLEM",
                            value:
                                history.getLatestValueOf("dailyActivityValue") !== "NO_PROBLEM"
                                    ? t(`anamnesis.quality.${history.getLatestValueOf("dailyActivityValue")}`)
                                    : "",
                            label: t("anamnesis.quality.daily-activities"),
                        }}
                    />
                )}
                {history.getLatestValueOf("discomfortValue") && (
                    <ConditionalLabelAndValue
                        {...{
                            switchValue: history.getLatestValueOf("discomfortValue") !== "NONE",
                            value:
                                history.getLatestValueOf("discomfortValue") !== "NONE"
                                    ? t(`anamnesis.quality.${history.getLatestValueOf("discomfortValue")}`)
                                    : "",
                            label: t("anamnesis.quality.pain"),
                        }}
                    />
                )}
                {history.getLatestValueOf("anxiousValue") && (
                    <ConditionalLabelAndValue
                        {...{
                            switchValue: history.getLatestValueOf("anxiousValue") !== "NO",
                            value:
                                history.getLatestValueOf("anxiousValue") !== "NO"
                                    ? t(`anamnesis.quality.${history.getLatestValueOf("anxiousValue")}`)
                                    : "",
                            label: t("anamnesis.quality.anxiety"),
                        }}
                    />
                )}
                <ConditionalLabelAndValue
                    {...{
                        switchValue: history.getLatestValueOf("scaleRateValue"),
                        value: history.getLatestValueOf("scaleRateValue"),
                        label: t("anamnesis.quality.self-rating"),
                    }}
                />
            </Flex>
        </HistoryContainerAndTitle>
    );
};

export default QualityOfLifeHistory;
